import api from './client'
import type { User, Permission } from '@/types/user'
import type { Entity } from '@/types/entity'

export interface UserInfoResponse {
  user: User
  permissions: Permission[]
  entities: Entity[]
  defaultTimeFrameId: number | null
}

export const userApi = {
  async getInfo(): Promise<UserInfoResponse> {
    const { data } = await api.get<UserInfoResponse>('/api/user/info')
    return data
  },
}
